const TopicOne = () => {
  return (
    <div className="quality-section-market">
      <div className="quality-header-market">
        <h1>Trade Smarter, Faster — All from Your Browser</h1>
        <p>
          Experience seamless online trading with MetaTrader Web Terminal.
          {/* Whether you’re hedging against inflation or capitalizing on short-term
          price shifts, The Pips provides an intuitive platform for both
          precision and performance. */}
        </p>
      </div>
    </div>
  );
};

export default TopicOne;
